import * as FlexLayout from "flexlayout-react";
import "../../node_modules/flexlayout-react/style/gray.css";
import TermListTable from '../components/TermListTable';
import SemanticTree from '../components/SemanticTree';
import TermDetails from '../components/TermDetails';
import TermDocsTable from '../components/TermDocsTable';
import { DragDropContext } from 'react-beautiful-dnd';
import { getCookie } from '../utils/utils';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { api } from "../services/config"
import { createContext, useContext, useEffect, useState } from "react";
import { ModelJson } from "../config/config";
import Tooltip from '@mui/material/Tooltip';
import { BsLayoutSplit, BsPin, BsPinFill } from "react-icons/bs"
import { MdFlip } from "react-icons/md"

export const ProjectContext = createContext();

function ProjectScreen() {
    const csrftoken = getCookie('csrftoken');
    const { profileState, setProfileState } = useOutletContext();
    const { projectRole: { projectId, projectName } = {} } = profileState;
    const [treeState, setTreeState] = useState({})
    const [termList, setTermList] = useState([])
    const [count, setCount] = useState(0)
    const [termData, setTermData] = useState({})
    const [projectState, setProjectState] = useState({
        addRelationIsOpen: false,
        addSCIsOpen: false,
        addSCTermIsOpen: false,
        metaTerms: {
            limit: 20,
            offset: 0,
            sortOrder: [],
        }
    })
    const [termClicked, setTermClicked] = useState(false)
    const [model] = useState(FlexLayout.Model.fromJson(ModelJson))

    useEffect(() => {
        const setProjectRole = async (id, projectName) => {
            try {
                const { data } = await axios.get(`${api.project}${id}/`);
                const projectRole = { projectId: id, role: data.permission, projectName, reviews: data.reviews };
                setProfileState((state) => ({ ...state, projectRole }));
                localStorage.setItem('projectRole', JSON.stringify(projectRole));
            } catch (error) {
                console.error(error);
            }
        };
        if (projectName) {
            setProjectRole(projectId, projectName);
        }
    }, [projectId, projectName]);

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
    }

    async function handleDragTerms(item, selectedTerms, semanticTarget, targetType) {
        const data = {
            terms: selectedTerms.length > 0
                ? selectedTerms
                : [parseInt(item)],
            hypernyms: (targetType === "subClasse") ? [semanticTarget] : [],
            bulk: selectedTerms.length > 0
        };
        await axios.post(api.project + projectId + '/sc/', data, { headers })

        const newTreeState = {
            item: `terms-${data.terms}`,
            updatedSemantics: semanticTarget ? [semanticTarget] : [0],
        };
        setTreeState(newTreeState);
    }

    async function handleDragSemantic(item, semanticSource, semanticTarget, targetType) {
        if (semanticTarget || semanticSource) {
            const data = {
                source: semanticSource || undefined,
            };
            if (targetType === "subClasse")
                data.target = semanticTarget;

            await axios.post(`${api.project}${projectId}/sc/${item}/move/`, data, { headers })

            const newTreeState = {
                item,
                semanticTarget: semanticTarget || 0,
                semanticSource: semanticSource || 0
            };
            setTreeState(newTreeState);
        }
    }

    async function handleDragEnd(result) {
        if (!result.destination) return;
        const droppableId = JSON.parse(result.destination.droppableId)
        const draggableId = JSON.parse(result.draggableId)
        const selectedRows = JSON.parse(localStorage.getItem("TermListTableState") || "{}")?.selectedRows?.data
        const selectedTerms = selectedRows.map(data => termList[data.dataIndex].id)

        const {
            id: item,
            hyper: semanticSource,
            type: itemType
        } = draggableId;

        const {
            itemId: semanticTarget,
            type: targetType
        } = droppableId

        if (itemType === "term") {
            await handleDragTerms(item, selectedTerms, semanticTarget, targetType);
        }
        else {
            await handleDragSemantic(item, semanticSource, semanticTarget, targetType);
        }
    }

    return (
        <div
            style={{
                position: "relative",
                height: "calc(100vh - 46.5px)",
                marginTop: "46.5px"
            }}
        >
            <ProjectContext.Provider
                value={{
                    treeState, setTreeState,
                    termList, setTermList,
                    count, setCount,
                    termData, setTermData,
                    projectState, setProjectState,
                    termClicked, setTermClicked,
                    projectId,
                    headers,
                }}
            >
                <DragDropContext onDragEnd={handleDragEnd}>
                    {model && <FlexLayout.Layout model={model} factory={factory} />}
                </DragDropContext>
            </ProjectContext.Provider>
        </div>
    )
}
export default ProjectScreen;

const factory = (node) => {
    var component = node.getComponent();

    if (component === "TermListTable") {
        return <TermListTable />;
    }
    else if (component === "SemanticTree") {
        return <SemanticTreeContainer {...{ nodeWidth: node._rect.width }} />;
    }
    else if (component === "TermDetails") {
        return <TermDetails />;
    }
    else if (component === "TermDocsTable") {
        return <TermDocsTable />;
    }
}

function SemanticTreeContainer({ nodeWidth }) {
    const {
        termData,
        termClicked, setTermClicked,
    } = useContext(ProjectContext);
    const [splitted, setSplitted] = useState(false)
    const [pinned, setPinned] = useState(false)
    const [triggerRender, setTriggerRender] = useState(false);
    const [triggerRender_, setTriggerRender_] = useState(false);
    const [associatedClicked, setAssociatedClicked] = useState(false);
    const [semanticClicked, setSemanticClicked] = useState(false)

    const [style] = useState({
        flexBasis: nodeWidth < 800 || !splitted ? '100%' : '50%',
    });

    useEffect(() => {
        if (!semanticClicked && !termClicked) {
            if ((!pinned || associatedClicked) && !splitted) {
                setTriggerRender(triggerRender => !triggerRender)
                associatedClicked && setAssociatedClicked(false);
            }
            setTriggerRender_(triggerRender_ => !triggerRender_)
        }
        semanticClicked && setSemanticClicked(false)
        termClicked && setTermClicked(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [termData]);

    return (<div
        className="h-100 d-flex semantic_tab__container"
        style={{ width: nodeWidth > 800 || !splitted ? "100%" : "200%" }}
    >
        <div className="action_btns">
            <Tooltip title={pinned ? "Désactiver la synchronisation" : "Activer la synchronisation"}>
                <button
                    className="pin_btn"
                    onClick={() => setPinned(pinned => !pinned)}
                >
                    {
                        pinned
                            ? <BsPinFill />
                            : <BsPin />
                    }
                </button>
            </Tooltip>

            <Tooltip title={splitted ? "Désactiver la fenêtre splited" : "Activer la fenêtre splited"}>
                <button
                    className="split_btn ml-2"
                    onClick={() => setSplitted(splitted => !splitted)}
                >
                    {splitted
                        ? <MdFlip size={"1.2em"} />
                        : <BsLayoutSplit strokeWidth={1.2} />
                    }
                </button>
            </Tooltip>
        </div>

        <SemanticTree
            style={style}
            triggerRender={triggerRender}
            setAssociatedClicked={setAssociatedClicked}
            setSemanticClicked={setSemanticClicked}
        />
        {splitted && <SemanticTree
            style={style}
            triggerRender={triggerRender_}
            splittedTree={true}
            setSemanticClicked={setSemanticClicked}
        />}
    </div>);
}
